import {TaxAuditRecordDetailsResponse} from "src/models/reports/TaxAuditRecordDetails";
import {Box, Container, Header} from "@amzn/awsui-components-react";
import {TPELoadingSpinner} from "src/components/shared/TPELoadingSpinner";
import React from "react";

function ValueWithLabel(props: any) {
    const { label } = props;
    return (
        <div>
            <Box margin={{ bottom: 'xxxs' }} color="text-label">
                {label}
            </Box>
            <div>{props.children}</div>
        </div>
    );
}

export default function TaxAuditRecordCalculationsDetails(props: { taxAuditRecordDetails: TaxAuditRecordDetailsResponse, loading: boolean}) {
    const {taxAuditRecordDetails, loading} = props;

    return <Container
        header={
            <Header variant="h2">Calculation Details</Header>
        }>
        <div className="polaris-content-container-tar-report-details">
            <TPELoadingSpinner loading={loading}>
                {taxAuditRecordDetails != null &&
                    <React.Fragment>
                        <div className="grid-item"><ValueWithLabel label="IC Transaction Grouping">{taxAuditRecordDetails.icTransactionGroup}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="IC Matching Id">{taxAuditRecordDetails.icMatchingId}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="Document Type">{taxAuditRecordDetails.documentType}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="Journal Currency">{taxAuditRecordDetails.journalCurrency}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="Currency Conversion Date">{taxAuditRecordDetails.currencyConvDate}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="TP Journal Source">{taxAuditRecordDetails.tpJournalSource}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="Export of Services">{taxAuditRecordDetails.exportOfServices}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="Created By">{taxAuditRecordDetails.createUser}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="Created Date">{taxAuditRecordDetails.createDate}</ValueWithLabel></div>
                    </React.Fragment>
                }
            </TPELoadingSpinner>
        </div>
    </Container>
}